import { AbstractControl } from "@angular/forms";
import { validationRegex } from "@obg/ngx.global";

export function asciiValidator(control: AbstractControl): { ascii: boolean } | null {
	if (!control.value) {
		return null;
	}
	return control.value.match(validationRegex.ascii) ? null : { ascii: false };
}
